var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 12.5H15.4166C17.025 12.5 18.3333 13.8083 18.3333 15.4167C18.3333 17.025 17.025 18.3333 15.4166 18.3333C13.8083 18.3333 12.5 17.025 12.5 15.4167V15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 10H15.4166C17.0166 10 18.3333 8.69169 18.3333 7.08335C18.3333 5.48335 17.0166 4.16669 15.4166 4.16669C13.8166 4.16669 12.5 5.47502 12.5 7.08335V7.50002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.5H7.75829C8.99996 7.5 9.99996 6.49166 9.99996 5.25833C9.99996 4.01666 8.99162 3.01666 7.75829 3.01666C6.51662 3.01666 5.51662 4.025 5.51662 5.25833V5.575",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.02d2e1fa9a76f5c24605c99ee0b7efd3.svg";
export { ForwardRef as ReactComponent };